import { ComplianceSectionComponent } from './compliance-section/compliance-section.component';
import { TenantNotificationsComponent } from './tenant-notifications/tenant-notifications.component';
import { WikiHelpComponent } from './wiki-help/wiki-help.component';
import { EntityInfoComponent } from './entity-info/entity-info.component';
import { EntityOverviewComponent } from './entity-overview/entity-overview.component';

export * from './compliance-section/compliance-section.component';
export * from './entity-info/entity-info.component';
export * from './entity-overview/entity-overview.component';
export * from './tenant-notifications/tenant-notifications.component';
export * from './wiki-help/wiki-help.component';

export const impliancyExports = [
  ComplianceSectionComponent,
  EntityInfoComponent,
  EntityOverviewComponent,
  TenantNotificationsComponent,
  WikiHelpComponent,
];

export const impliancyDeclarations = [...impliancyExports];
